import * as React from "react";
const SvgFiRrWhale = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-whale_svg__a)">
      <path
        fill="#062147"
        d="M16 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m8-.999v1.5c0 3.308-2.69 6-6 6H8.727C3.915 24 0 20.084 0 15.272c0-3.369.987-6.629 2.855-9.43l.493-.739A5.58 5.58 0 0 1 .004.65C-.038.301.235-.023.586.002 4.253.262 5.5 2.775 5.5 2.775S6.703.26 10.414.001c.351-.024.624.3.582.65a5.57 5.57 0 0 1-4.128 4.72l-.463 2.747a29 29 0 0 0-.378 3.593c2.872-2.379 5.88-3.71 8.474-3.71h1.008C20.192 8.004 24 11.817 24 16.5m-2 0a6.51 6.51 0 0 0-6.494-6.5H14.5c-2.558 0-5.845 1.76-8.792 4.706A.998.998 0 0 1 4 14v-1.059c0-1.724.146-3.458.432-5.156l.158-.938C2.942 9.318 2 12.301 2 15.273A6.735 6.735 0 0 0 8.727 22H18c2.206 0 4-1.794 4-4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-whale_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWhale;
